import React from "react";
import Suppliers from "pages/Purchase/Suppliers";

const ConsultantsList = () => {
  return <Suppliers type="Consultant" component="consultants" />;
};

export default ConsultantsList;
